<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'inspection',
      getDataUrl:'detail',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/inspect` },
        { name: "车辆年检", path: `/vehicle/inspect` },
        { name: "年检详情" },
      ],
      viewMode: true,
      form: {
        // license: undefined,
        // maunit: undefined,
        // rstarttime: undefined,
        // money: undefined,
        // repair: undefined,
      },
      rules: {

      },
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "select",
        },
        {
          label: "车辆类型",
          keyName: "vtype",
          err: "请填写车辆类型",
          type: "select",
          options: [],
        },
        {
          label: "最近一次年检时间",
          keyName: "inspection_at",
          err: "请选择时间",
          type: "date",
        },
        {
          label: "最近一次年检费用",
          keyName: "cost",
          err: "请填写最近一次年检费用",
          type: "number",
        },
        {
          label: "年检机构",
          keyName: "institution",
          err: "请填写年检机构",
          type: "text",
        },
        {
          label: "下次年检时间",
          keyName: "next_inspection_at",
          err: "请选择时间",
          type: "date"
        },
        {
          label: "更新时间",
          keyName: "updated_at",
          err: "请选择时间",
          type: "date"
        },
        {
          label: "备注信息",
          keyName: "inspection_desc",
          err: "请填写内容",
          type: "textarea",
          rows: '3',
          className: 'block',
        },
      ],
      inspection: 1,
    };
  },
  methods: {    
    getDateParamsHandler(params) {
      params.inspection = this.inspection
      console.log(params)
      return params
    },
  },
  created() {
    const { inspection } = this.$route.query
    if (inspection) {
      this.inspection = inspection
    }
  },
  mounted() {
    // this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
